namespace $.$$ {
	$mol_style_define( $shm_mentionstat_form, {
		flex: { grow: 1, shrink: 1 },
		minWidth: 0,
		Social_title: { overflowWrap: 'anywhere', minWidth: 0 },
		Mass_title: { overflowWrap: 'anywhere', minWidth: 0 },
		Files_group: {
			flex: { wrap: 'nowrap' },
		},
		Social_field: {
			flex: { basis: 0, grow: 1, shrink: 1 },
			minWidth: 0,
			Content: {
				flex: { direction: 'column' },
			},
		},
		Mass_field: {
			flex: { basis: 0, grow: 1, shrink: 1 },
			minWidth: 0,
			Content: {
				flex: { direction: 'column' },
			},
		},
	} )
}
